import React from 'react';
import { View } from 'react-native-web';
import LayoutContainer from './LayoutContainer';
import RegularText from '../Text/RegularText';

//= ========================================================================

const LayoutMenu = ({
  globJSON,
  onConfigChanged,
  paragraph,
  list,
}) => (
  <View>
    <RegularText>{paragraph}</RegularText>
    <View style={{
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      gap: 20,
    }}
    >
      {list.map((listParams) => <LayoutContainer globJSON={globJSON} onConfigChanged={onConfigChanged} object={listParams} />)}
    </View>
  </View>

);
export default LayoutMenu;
